<template>
  <button @click="showToast = !showToast">showToast</button>
  <div
    class="toast fade bg-light"
    :class="{ show: showToast }"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="toast-header">
      <strong class="me-auto">Bootstrap</strong>
      <small>11 mins ago</small>
      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
    <div class="toast-body">Hello, world! This is a toast message.</div>
  </div>
</template>
<script setup>
import { ref } from "vue";
const showToast = ref(false);
</script>
